import { useEffect, useState } from "react";

/**
 * Keeps something on screen for a moment after it is closed, so it can play
 * its way out instead of vanishing: `mounted` says whether to render it, and
 * `closing` is the class that runs the exit animation. Opening is immediate;
 * the enter animation is the element's own.
 */
export function usePresence(open: boolean, exitMs: number): { readonly mounted: boolean; readonly closing: boolean } {
  const [mounted, setMounted] = useState(open);
  useEffect(() => {
    if (open) {
      setMounted(true);
      return;
    }
    const timer = setTimeout(() => setMounted(false), exitMs);
    return () => clearTimeout(timer);
  }, [open, exitMs]);
  return { mounted: open || mounted, closing: !open && mounted };
}
